import { buildMuiThemeWith as buildMuiTheme } from './theme/createMuiTheme';

import { colors } from '@budgit/design-tokens';

export const theme = buildMuiTheme(colors);

// Export colors for direct component usage
export { colors };

export const commonStyles = {
  mainButton: {
    backgroundColor: colors.primary,
    color: colors.secondary,
    padding: '15px 40px',
    fontSize: '1.2rem',
    fontWeight: 'bold',
    borderRadius: '50px',
    '&:hover': {
      backgroundColor: colors.primary,
    },
  },
  featureSection: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    zIndex: '1',
  },
  slantedSection: {
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: colors.primary,
      transform: 'skewY(8deg)',
      transformOrigin: 'top left',
      transition: 'transform 0.3s ease-out',
    },
  },
};